export enum GoogleClassState {
  Unspecified = 'COURSE_STATE_UNSPECIFIED',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Provisioned = 'PROVISIONED',
  Declined = 'DECLINED',
  Suspsended = 'SUSPENDED',
}

export interface GoogleDriveFolder {
  id: string
  title: string
  alternateLink: string
}

export interface GoogleClassMaterial_Base {
  title: string
  thumbnailUrl: string
}

export interface GoogleClassMaterial_DriveFile
  extends GoogleClassMaterial_Base {
  id: string
  alternateLink: string
}

export interface GoogleClassMaterial_YouTubeVideo
  extends GoogleClassMaterial_Base {
  id: string
  alternateLink: string
}

export interface GoogleClassMaterial_Form extends GoogleClassMaterial_Base {
  formUrl: string
  responseUrl: string
}

export interface GoogleClassMaterial_Link extends GoogleClassMaterial_Base {
  url: string
}

export type GoogleClassMaterial =
  | GoogleClassMaterial_DriveFile
  | GoogleClassMaterial_YouTubeVideo
  | GoogleClassMaterial_Form
  | GoogleClassMaterial_Link

export interface GoogleClassMaterialSet {
  title: string
  materials: Array<GoogleClassMaterial>
}

export interface GoogleClass {
  id: string
  name: string
  section: string
  descriptionHeading: string
  description: string
  room: string
  ownerId: string
  creationTime: string
  updateTime: string
  enrollmentCode: string
  courseState: GoogleClassState
  alternateLink: string
  teacherGroupEmail: string
  courseGroupEmail: string
  teacherFolder: GoogleDriveFolder
  courseMaterialSets: GoogleClassMaterialSet
  guardiansEnabled: boolean
  calendarId: string
}

export interface GoogleUserProfile {
  id: string
  name: {
    givenName: string
    familyName: string
    fullName: string
  }
  emailAddress: string
  photoUrl: string
  permissions: 'PERMISSION_UNSPECIFIED' | 'CREATE_COURSE'
  verifiedTeacher: boolean
}
export interface GoogleTeacher {
  courseId: string
  userId: string
  profile: GoogleUserProfile
}

// TODO: Declare proper gapi type
// export declare const window: Window & typeof globalThis & { gapi: any }
export interface GAPIWindow {
  gapi: unknown
  [key: string]: unknown
}
